import { render, staticRenderFns } from "./competeCategoryList.vue?vue&type=template&id=1bb69158&"
import script from "./competeCategoryList.vue?vue&type=script&lang=js&"
export * from "./competeCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports